module.exports = __webpack_public_path__ + "static/2-formation-deformation-s2-a1-df096566b724d09b518c3a8a43917e45.jpg";